let LtoCartItem = function(productSku, productQty, productMaxQty){
    let _sku = productSku;
    let _qty = ensureIntVal(productQty);
    let _maxQty = ensureIntVal(productMaxQty);

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    this.toJSON = function(){
        let ltoCartItem = {};
        ltoCartItem.sku = _sku;
        ltoCartItem.qty = _qty;
        ltoCartItem.maxQty = _maxQty;

        return ltoCartItem;
    };

    this.setSku = function(productSku){
        _sku = productSku;
    };

    this.setQty = function(productQty){
        _qty = ensureIntVal(productQty);
    };

    this.setMaxQty = function(productMaxQty){
        _maxQty = ensureIntVal(productMaxQty);
    };

    this.getSku = function(){
        return _sku;
    };

    this.getQty = function(){
        return _qty;
    };

    this.getMaxQty = function(){
        return _maxQty;
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function ensureIntVal(val){
        let intVal;
        if (typeof val === 'number'){
            intVal = val;
        }
        else if (typeof val === 'string'){
            intVal = parseInt(val);
        }
        return intVal;
    }

};

export default LtoCartItem;